import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Signin from '@techsoftware/happay-widgets/Signin';
import SSOList from "../../constants/ssoListConfig";
import { Link } from "react-router-dom";


export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onSignIn = this.onSignIn.bind(this);
    this._handleSSOButtonClick = this._handleSSOButtonClick.bind(this);
  }

  onSignIn(value) {
    this.props.onFetchAuthMode(value);
  }

  returnSSOPage = () => {
    return (
        <Link className="pointer font-12 fw-500 primary-color" to="/login/sso">
            Login via single sign-on (SSO)
        </Link>
    );
  };

  _handleSSOButtonClick() {
    this.props._checkSSO();
  }

  render() {
    const { productLogo, privacyPolicyUrl, termOfUseUrl } = this.props;
    const isSSOLogin = SSOList.isSSO();
    return (
      <Signin
        containerClassName="signin-container"
        logo={productLogo}
        onSignIn={this.onSignIn}
        // breakPoints={breakPoints}
        countryCode={this.props.countryCodes}
        // footerSubHeader={"weAreAlsoAvailable"}
        privacyPolicyUrl={privacyPolicyUrl}
        termOfUseUrl={termOfUseUrl}
        privacyPolicyText="Privacy Policy"
        termOfUseText="Terms of Use"
        // androidAppUrl={`https://play.google.com/store/apps/details?id=com.happay.android.v2&hl=en`}
        // iphoneAppUrl={`https://itunes.apple.com/za/app/happay-enterprise/id1169381152?mt=8`}
        SSOLogin={isSSOLogin}
        SSOPage={!isSSOLogin && this.returnSSOPage()}
        SSOLoginText={"Sign in using SSO"}
        SSOLoginHeaderText={'Sign in to your account'}
        SSOLoginClick={this._handleSSOButtonClick}
      />
    );
  }
}

Login.propTypes = {
  onFetchAuthMode: PropTypes.func,
  productLogo: PropTypes.node,
  privacyPolicyUrl: PropTypes.string,
  termOfUseUrl: PropTypes.string,
  countryCodes: PropTypes.array,
};

Login.defaultProps = {
  countryCodes: [],
};
